import PropTypes from 'prop-types';

import InfoBanner from '../../../shared/InfoBanner';
import {sanitizeContent} from 'js/shared/security';

const DecreasingBanner = ({className, data}) => {
  return (
    <InfoBanner color="blue" className={className}>
      <div dangerouslySetInnerHTML={{__html: sanitizeContent(data.decreaseBannerText)}} />
    </InfoBanner>
  )
}

DecreasingBanner.propTypes = {
  className: PropTypes.string,
  data: PropTypes.shape({
    decreaseBannerText: PropTypes.string.isRequired
  }).isRequired
}

export default DecreasingBanner;
